/**
 * Where a link Wundo sent into the web app was shared. Only surfaces outside
 * the app: a link in the web drawer is a click inside the app, not a way in.
 */
export const LINK_SOURCES = ['msteams', 'slack', 'email'] as const;

export type LinkSource = (typeof LINK_SOURCES)[number];

/** The query params an outbound link carries, read once by the app on arrival. */
export const LINK_SOURCE_PARAM = 'src';
export const LINK_NOTIFICATION_PARAM = 'n';

/** What the app reports when a signed-in person arrives through such a link. */
export interface LinkClickRequest {
  src: LinkSource;
  /** The stored notification message the link was the button of. */
  n?: number;
  /** The app path the link opened, without its query. */
  path: string;
}
